var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Plotly", {
        attrs: {
          layout: _vm.chart.layout,
          data: _vm.chart.data,
          "display-mode-bar": false,
        },
      }),
      _c(
        "v-row",
        { staticClass: "justify-space-around", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [_c("TableSimple", { attrs: { data: _vm.tableValues } })],
            1
          ),
          _c("v-col", { attrs: { cols: "6" } }, [
            _c("p", { staticClass: "pl-4" }, [
              _vm._v(_vm._s(_vm.settings.text)),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }